// Import Vue and SsrCarousel from the source file.
import VueSplide from '@splidejs/vue-splide'
import '@splidejs/vue-splide/css/core'

export default defineNuxtPlugin((nuxtApp) => {
  // Register the 'ssr-carousel' component.
  nuxtApp.vueApp.use(VueSplide)
})
